module.exports = __webpack_public_path__ + "static/media/icons8-instagram-logo-500.1099136e.png";